"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.object.seal");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _editorForVue = require("@wangeditor/editor-for-vue");
var _customizePageManagement = require("@/api/operationManagement/customizePageManagement");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Editor: _editorForVue.Editor,
    Toolbar: _editorForVue.Toolbar
  },
  data: function data() {
    return {
      dialogVisible: false,
      conditionType: {},
      // 条件
      ruleForm: {
        id: null,
        title: '',
        text: ''
      },
      rules: {
        title: [{
          required: true,
          message: '请输入课程标题',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '长度在 1 到 100 个字符',
          trigger: 'blur'
        }]
      },
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: function () {
              var _customUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, insertFn) {
                var pictureUrl, _t;
                return (0, _regenerator2.default)().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      _context.p = 0;
                      _context.n = 1;
                      return (0, _ossUpload.uploadOSS)(file);
                    case 1:
                      pictureUrl = _context.v;
                      insertFn(pictureUrl);
                      _context.n = 3;
                      break;
                    case 2:
                      _context.p = 2;
                      _t = _context.v;
                      console.log('error ->', _t);
                    case 3:
                      return _context.a(2);
                  }
                }, _callee, null, [[0, 2]]);
              }));
              function customUpload(_x, _x2) {
                return _customUpload.apply(this, arguments);
              }
              return customUpload;
            }()
          }
        }
      },
      mode: 'default',
      // or 'simple'
      EditorOpen: false
    };
  },
  methods: {
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor);
      // 一定要用 Object.seal() ，否则会报错
    },
    open: function open(data) {
      this.conditionType = data;
      this.EditorOpen = true;
      if (data.type === 'add') {
        // console.log('添加')
      } else {
        console.log(data);
        this.ruleForm.id = data.item.id;
        this.ruleForm.title = data.item.title;
        this.ruleForm.text = data.item.text;
      }
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.ruleForm = {
        id: null,
        title: '',
        text: ''
      };
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.EditorOpen = false;
      // const editor = this.editor
      // if (editor == null) return
      // editor.destroy() // 组件销毁时，及时销毁编辑器
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.conditionType.type === 'add') {
            _this.pageSavePage();
          } else {
            _this.pageUpdatePage();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.title = '';
      this.ruleForm.text = '';
    },
    // 保存海报
    pageSavePage: function () {
      var _pageSavePage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context2.n = 1;
              return (0, _customizePageManagement.pageSavePage)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '添加成功'
                });
                this.onClose();
                this.$emit('refresh');
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function pageSavePage() {
        return _pageSavePage2.apply(this, arguments);
      }
      return pageSavePage;
    }(),
    // 更新海报
    pageUpdatePage: function () {
      var _pageUpdatePage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context3.n = 1;
              return (0, _customizePageManagement.pageUpdatePage)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.onClose();
                this.$emit('refresh');
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function pageUpdatePage() {
        return _pageUpdatePage2.apply(this, arguments);
      }
      return pageUpdatePage;
    }()
  }
};